import React from 'react';
import { Link } from 'react-router-dom';

export default class ErrorTemplate extends React.Component {
  render() {
    const { errorCode, errorMessage } = this.props;
    return (
      <div className="error-template">
        <h1 className="error-code">{errorCode}</h1>
        <p className="error-message">{errorMessage}</p>
        <Link to="/" className="mt-6 text-blue-500 underline">Go back to Home</Link>
      </div>
    );
  }
}

